<template>
  <FinderCard
    data-test="finder-usage-card"
    :title="criterion.title"
    :tooltip="criterion.tooltip"
  >
    <ul class="flex w-full flex-col gap-8">
      <li v-for="option in options" :key="option.id" class="w-full">
        <RevButtonBase
          :aria-pressed="isSelected(option.id)"
          class="flex w-full items-center rounded-lg border px-16 py-14 transition-colors"
          :class="
            isSelected(option.id)
              ? 'border-action-brand-mid bg-action-brand-low text-static-default-hi'
              : 'border-transparent bg-surface-default-hi text-static-default-hi hover:bg-surface-default-mid'
          "
          :data-state="isSelected(option.id) ? 'selected' : 'unselected'"
          data-test="finder-usage-pill"
          @click="toggleId(option.id)"
        >
          <span class="grow text-left heading-3">{{ option.label }}</span>
        </RevButtonBase>
      </li>
    </ul>
  </FinderCard>
</template>

<script lang="ts" setup>
import { RevButtonBase } from '@ds/components/ButtonBase'

import type {
  FinderOption,
  FinderUsageCriterion,
} from '../../../../composables/useFinder/useFinder.types'
import FinderCard from '../FinderCard/FinderCard.vue'

defineProps<{
  criterion: FinderUsageCriterion
  options: FinderOption[]
}>()

const selectedIds = defineModel<string[]>('selectedIds', { default: () => [] })

function isSelected(id: string): boolean {
  return selectedIds.value.includes(id)
}

function toggleId(id: string): void {
  const current = selectedIds.value

  selectedIds.value = current.includes(id)
    ? current.filter((v) => v !== id)
    : [...current, id]
}
</script>
